<button
  class="back-to-top"
  [class.is-visible]="isVisible()"
  type="button"
  aria-label="Back to top"
  (click)="scrollToTop()"
  title="Go to top">
  <svg
    class="back-to-top__icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round">
    <polyline points="18 15 12 9 6 15"></polyline>
  </svg>
</button>
